'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
require('./social-button-8479390a.js');
var iconButtons = require('./icon-buttons-442762e4.js');
var element = require('./element-2cae4d89.js');
var hooks_useTextRepresentation = require('./hooks/use-text-representation/index.js');
var hooks_useWrappedFunction = require('./hooks/use-wrapped-function/index.js');
var iconLibrary_notificationIcons_errorDark = require('./icon-library/notification-icons/error-dark/index.js');
var iconLibrary_notificationIcons_errorLight = require('./icon-library/notification-icons/error-light/index.js');
var iconLibrary_notificationIcons_informationDark = require('./icon-library/notification-icons/information-dark/index.js');
var iconLibrary_notificationIcons_informationLight = require('./icon-library/notification-icons/information-light/index.js');
var iconLibrary_notificationIcons_successDark = require('./icon-library/notification-icons/success-dark/index.js');
var iconLibrary_notificationIcons_warningDark = require('./icon-library/notification-icons/warning-dark/index.js');
var iconLibrary_systemIcons_microIcons_closeIcon = require('./icon-library/system-icons/micro-icons/close-icon/index.js');
var styled = require('styled-components');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');
var component = require('./component-21a580e6.js');
var iconLink = require('./icon-link-f19c861a.js');
var element$1 = require('./element-2d0b0a9a.js');
var defaultTheme = require('./defaultTheme-068d5ee4.js');
var withStyles = require('./withStyles-b393a9eb.js');
var Paper = require('./Paper-219dcd73.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var styles$2 = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = /*#__PURE__*/React__namespace.forwardRef(function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/React__namespace.createElement(Paper.Paper, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Card.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: defaultTheme.PropTypes.bool
} : void 0;
var Card$1 = withStyles.withStyles(styles$2, {
  name: 'MuiCard'
})(Card);

var styles$1 = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var CardActions = /*#__PURE__*/React__namespace.forwardRef(function CardActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = defaultTheme._objectWithoutProperties(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? CardActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: defaultTheme.PropTypes.bool
} : void 0;
var CardActions$1 = withStyles.withStyles(styles$1, {
  name: 'MuiCardActions'
})(CardActions);

var styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  }
};
var CardContent = /*#__PURE__*/React__namespace.forwardRef(function CardContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "component"]);

  return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? CardContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
var CardContent$1 = withStyles.withStyles(styles, {
  name: 'MuiCardContent'
})(CardContent);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var notificationBackgroundRadius = '4px';
var notificationBackgroundFillRadius = '6px';

// Border
var notificationBorder = '1px';
var notificationBackgroundFill = '6px';
// Spacing
var notificationFontSpacing = element.ownUpWhiteTheme.spacing(1) + 'px';
var notificationBackgroundSpacing = element.ownUpWhiteTheme.spacing(3) + 'px';
var notificationIconSpacing = element.ownUpWhiteTheme.spacing(2) + 'px';
var linkSpacingGroup = element.ownUpWhiteTheme.spacing(1) + 'px';
var notificationIconSize = '1.5rem';

// Wrapper div for the notification elements
var StyledNotification = styled__default['default'].div(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  .root: {\n    min-width: 200px;\n    width: 100%;\n  }\n"])));

// Card container for the notifications

var StyledCard = styled__default['default'](Card$1)(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column-reverse;\n  border-radius: ", " ", "\n    ", " ", ";\n  ", "\n"])), notificationBackgroundFillRadius, notificationBackgroundRadius, notificationBackgroundRadius, notificationBackgroundFillRadius, function (props) {
  var colorScheme = props.theme.notificationColors[props.variation][props.type];
  return styled.css(["background-color:", ";box-shadow:", ";&.MuiCard-root{border-left:", " solid ", ";}&", "{outline:2px solid ", ";border-radius:2px;"], colorScheme.notificationBackgroundColor, props.variation === 'default' ? "4.0px 4.0px 8.0px 0px ".concat(props.theme.notificationColors.notificationShadow, ",\n       inset 0px ").concat(notificationBorder, " ").concat(colorScheme.notificationBorderColor, ", \n       inset -").concat(notificationBorder, " -").concat(notificationBorder, " ").concat(colorScheme.notificationBorderColor) : "inset 0px ".concat(notificationBorder, " ").concat(colorScheme.notificationBorderColor, ",\n       inset -").concat(notificationBorder, " -").concat(notificationBorder, " ").concat(colorScheme.notificationBorderColor), notificationBackgroundFill, colorScheme.notificationBackgroundFillColor, focusVisibleSelector.focusVisibleSelectorMixin, props.theme.notificationColors.notificationBorderFocusColor);
});
var StyledCardActions = styled__default['default'](CardActions$1)(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  padding: 0px;\n  margin-top: ", ";\n  margin-right: ", ";\n  justify-content: ", ";\n  &.MuiCardActions-spacing > :not(:first-child) {\n    margin-left: ", ";\n  }\n"])), notificationBackgroundSpacing, notificationBackgroundSpacing, function (_ref) {
  var $hasCloseIcon = _ref.$hasCloseIcon;
  return $hasCloseIcon ? 'space-between' : undefined;
}, notificationIconSpacing);
var TitleAndDescriptionDiv = styled__default['default'].div(_templateObject4 || (_templateObject4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  color: ", ";\n  margin-left: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.notificationColors.notificationFontColor;
}, notificationBackgroundSpacing);

// Card content for optional links below the description

var StyledCardContent = styled__default['default'](CardContent$1)(_templateObject5 || (_templateObject5 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  padding: ", " ", " ", "\n    ", ";\n"])), linkSpacingGroup, notificationBackgroundSpacing, notificationBackgroundSpacing, function (_ref3) {
  var $hasIcon = _ref3.$hasIcon;
  return $hasIcon ? '64px' : notificationBackgroundSpacing;
});

// Icons

var OwnUpNotificationIcon = styled__default['default'](component.OwnUpIcon)(_templateObject6 || (_templateObject6 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), notificationIconSize, notificationIconSize);

// Font
var NotificationDescriptionStyle = element$1.OwnUpBody;
var NotificationDescriptionSmallStyle = styled__default['default'](element$1.OwnUpSmallBody)(_templateObject7 || (_templateObject7 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), notificationFontSpacing);
var NotificationTitleStyle = element$1.OwnUpBodyMedium;

// Link content
var notificationLinkStyles = styled.css(["&:not(:first-child) p{padding-top:", ";}&:not(:first-child) span{padding-top:", ";}"], linkSpacingGroup, linkSpacingGroup);

// A variant of the IconLink with zero horizontal padding around the href a tag,
// and some padding on top.
// Necessary for the styling specifications of icon links to be used in notifications.
styled__default['default'](iconLink.IconLink)(_templateObject8 || (_templateObject8 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n"])), notificationLinkStyles);

var _excluded = ["title", "description", "children", "type", "variation", "$hasIcon", "$hasCloseIcon"];
/**
 * Determine which icon to show based on notification variation/type.
 *
 * @param type - error | warning | info | warning
 * @param variation - default | urgent
 * @param $hasIcon - boolean that determines whether to show the icon or not
 * @returns - which icon to show
 */
var useNotificationIcon = function useNotificationIcon(type, variation, $hasIcon) {
  return React.useMemo(function () {
    var icon;
    if ($hasIcon) {
      switch (type) {
        case 'error':
          icon = variation === 'default' ? /*#__PURE__*/React__default['default'].createElement(iconLibrary_notificationIcons_errorLight.ErrorLightIcon, null) : /*#__PURE__*/React__default['default'].createElement(iconLibrary_notificationIcons_errorDark.ErrorDarkIcon, null);
          break;
        case 'warning':
          icon = /*#__PURE__*/React__default['default'].createElement(iconLibrary_notificationIcons_warningDark.WarningDarkIcon, null);
          break;
        case 'info':
          icon = variation === 'default' ? /*#__PURE__*/React__default['default'].createElement(iconLibrary_notificationIcons_informationLight.InformationLightIcon, null) : /*#__PURE__*/React__default['default'].createElement(iconLibrary_notificationIcons_informationDark.InformationDarkIcon, null);
          break;
        case 'success':
          icon = /*#__PURE__*/React__default['default'].createElement(iconLibrary_notificationIcons_successDark.SuccessDarkIcon, null);
          break;
        default:
          icon = /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null);
      }
      return /*#__PURE__*/React__default['default'].createElement(OwnUpNotificationIcon, {
        style: {
          paddingLeft: "".concat(notificationBackgroundSpacing)
        },
        variation: variation,
        type: type,
        icon: icon,
        "aria-hidden": "true"
      });
    } else {
      return null;
    }
  }, [variation, type, $hasIcon]);
};
var OwnUpNotification = function OwnUpNotification(_ref) {
  var title = _ref.title,
    description = _ref.description,
    children = _ref.children,
    type = _ref.type,
    variation = _ref.variation,
    $hasIcon = _ref.$hasIcon,
    $hasCloseIcon = _ref.$hasCloseIcon,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  var _useState = React.useState(true),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    showNotification = _useState2[0],
    setShowNotification = _useState2[1];
  var dismissNotification = hooks_useWrappedFunction.useWrappedFunction(function () {
    return setShowNotification(false);
  });
  var renderDescription = React.useMemo(function () {
    return title ? /*#__PURE__*/React__default['default'].createElement(NotificationDescriptionSmallStyle, {
      variant: "body1"
    }, description) : /*#__PURE__*/React__default['default'].createElement(NotificationDescriptionStyle, {
      variant: "body1"
    }, description);
  }, [title, description]);
  var derivedAriaLive = variation !== 'urgent' || type === 'info' || type === 'success' ? 'polite' : 'assertive';
  var derivedAriaDescribedBy = hooks_useTextRepresentation.useTextRepresentation(title ? title : description);
  var renderNotificationIcon = useNotificationIcon(type, variation, $hasIcon);
  var renderCloseIcon = React.useMemo(function () {
    return variation === 'default' && !$hasIcon && $hasCloseIcon && /*#__PURE__*/React__default['default'].createElement(iconButtons.OwnUpIconButtonNeutral, {
      name: "Dismiss Notification",
      size: 1.5,
      icon: /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_microIcons_closeIcon.MicroCloseIcon, null),
      onClick: dismissNotification,
      "aria-label": "close"
    });
  }, [variation, $hasIcon, $hasCloseIcon, dismissNotification]);
  return /*#__PURE__*/React__default['default'].createElement(StyledNotification, _rollupPluginBabelHelpers._extends({
    description: description
  }, props), showNotification && /*#__PURE__*/React__default['default'].createElement(StyledCard, {
    variation: variation,
    type: type,
    "aria-live": derivedAriaLive,
    "aria-describedby": derivedAriaDescribedBy,
    description: description,
    tabIndex: 0
    // The below CSS line gets overriden when placed in the styles file.
    ,
    style: {
      paddingBottom: children ? 0 : "".concat(notificationBackgroundSpacing)
    }
  }, /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: element.ownUpWhiteTheme
  }, children && /*#__PURE__*/React__default['default'].createElement(StyledCardContent, {
    $hasIcon: $hasIcon
  }, children), /*#__PURE__*/React__default['default'].createElement(StyledCardActions, {
    $hasCloseIcon: $hasCloseIcon
  }, renderNotificationIcon, /*#__PURE__*/React__default['default'].createElement(TitleAndDescriptionDiv, {
    description: description
  }, title && /*#__PURE__*/React__default['default'].createElement(NotificationTitleStyle, {
    variant: "body1"
  }, title), renderDescription), renderCloseIcon))));
};

var OwnUpDefaultErrorNotification = function OwnUpDefaultErrorNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "default",
    type: "error"
  }));
};
var OwnUpDefaultWarningNotification = function OwnUpDefaultWarningNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "default",
    type: "warning"
  }));
};
var OwnUpDefaultInfoNotification = function OwnUpDefaultInfoNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "default",
    type: "info"
  }));
};
var OwnUpDefaultSuccessNotification = function OwnUpDefaultSuccessNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "default",
    type: "success"
  }));
};

var OwnUpUrgentErrorNotification = function OwnUpUrgentErrorNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "urgent",
    type: "error"
  }));
};
var OwnUpUrgentWarningNotification = function OwnUpUrgentWarningNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "urgent",
    type: "warning"
  }));
};
var OwnUpUrgentInfoNotification = function OwnUpUrgentInfoNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "urgent",
    type: "info"
  }));
};
var OwnUpUrgentSuccessNotification = function OwnUpUrgentSuccessNotification(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNotification, _rollupPluginBabelHelpers._extends({}, props, {
    variation: "urgent",
    type: "success"
  }));
};

exports.OwnUpDefaultErrorNotification = OwnUpDefaultErrorNotification;
exports.OwnUpDefaultInfoNotification = OwnUpDefaultInfoNotification;
exports.OwnUpDefaultSuccessNotification = OwnUpDefaultSuccessNotification;
exports.OwnUpDefaultWarningNotification = OwnUpDefaultWarningNotification;
exports.OwnUpUrgentErrorNotification = OwnUpUrgentErrorNotification;
exports.OwnUpUrgentInfoNotification = OwnUpUrgentInfoNotification;
exports.OwnUpUrgentSuccessNotification = OwnUpUrgentSuccessNotification;
exports.OwnUpUrgentWarningNotification = OwnUpUrgentWarningNotification;
//# sourceMappingURL=urgent-notifications-e2441552.js.map
